document.addEventListener("DOMContentLoaded", function () {
    // Wähle alle Radio-Buttons mit dem Namen "properties[Ausrichtung]"
    const radios = document.querySelectorAll('input[name="properties[Ausrichtung]"]');
    const motivElements = document.querySelectorAll('.motiv'); // Alle Elemente mit der Klasse .motiv

    radios.forEach(radio => {
        radio.addEventListener('change', function () {
            // Prüfen, ob der zweite Radio-Button ausgewählt ist
            if (radios[1].checked) {
                motivElements.forEach(motiv => motiv.classList.add('reverse'));
            } else {
                motivElements.forEach(motiv => motiv.classList.remove('reverse'));
            }
        });
    });
});
